import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gradient-to-r from-gray-900 to-gray-800 border-t border-gray-700 mt-auto">
      <div className="container mx-auto px-6 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Left side - Links */}
          <div className="flex items-center gap-6 text-sm">
            <Link 
              to="/" 
              className="text-gray-400 hover:text-white transition-colors duration-200"
            >
              Home
            </Link>
            <Link 
              to="/privacy" 
              className="text-gray-400 hover:text-white transition-colors duration-200"
            >
              Privacy Policy
            </Link>
          </div>

          {/* Right side - Copyright */}
          <div className="text-gray-400 text-sm">
            © {new Date().getFullYear()} CS2 Lineups
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 